import { commonStore } from '.';
import { observable, action, computed } from 'mobx';

import { api } from '../services';

class PoiStore {
  @observable _pois = [];

  constructor(commonStore) {
    this.commonStore = commonStore;
  }

  @computed
  get poilist() {
    const fromDealer = this.commonStore.dealer && this.commonStore.dealer.pointOfInterests ? this.commonStore.dealer.pointOfInterests : [];
    return this._pois.length === 0 ? fromDealer : this._pois;
  }

  search(query) {
    return new Promise(resolve => {
      const found = this.poilist.filter(
        item =>
          query !== '' &&
          Object.keys(item).some(key =>
            String(item[key])
              .toLowerCase()
              .includes(query.toLowerCase())
          )
      );
      resolve(found);
    });
  }

  @action
  create(POIToSave) {
    return api('addPOI', POIToSave).then(response => {
      this._pois = [].concat(response, this.poilist);
      return response;
    });
  }

  @action
  delete(POIToDelete) {
    const { id } = POIToDelete;
    return api('deletePOI', id).then(response => {
      this._pois = this.poilist.filter(poi => poi.id !== id);
      return response;
    });
  }
}

export default new PoiStore(commonStore);



// WEBPACK FOOTER //
// ./src/stores/poiStore.js